import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { ZoomIn, ZoomOut, RotateCcw } from 'lucide-react';

const ZOOM_KEY = 'app_zoom_level';
const ZOOM_LEVELS = [100, 125, 150];

const ZoomControl = () => {
  const [zoom, setZoom] = useState(() => {
    const saved = localStorage.getItem(ZOOM_KEY);
    return saved ? parseInt(saved) : 100;
  });

  useEffect(() => {
    applyZoom(zoom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const applyZoom = (level) => {
    const baseMobile = 20;
    const baseDesktop = 18;
    const factor = level / 100;
    const isMobile = window.innerWidth <= 768;
    const base = isMobile ? baseMobile : baseDesktop;
    document.documentElement.style.fontSize = `${base * factor}px`;
    localStorage.setItem(ZOOM_KEY, level.toString());
  };

  const cycleZoom = () => {
    const currentIdx = ZOOM_LEVELS.indexOf(zoom);
    const nextIdx = (currentIdx + 1) % ZOOM_LEVELS.length;
    const newZoom = ZOOM_LEVELS[nextIdx];
    setZoom(newZoom);
    applyZoom(newZoom);
  };

  const zoomIn = () => {
    const currentIdx = ZOOM_LEVELS.indexOf(zoom);
    if (currentIdx < ZOOM_LEVELS.length - 1) {
      const newZoom = ZOOM_LEVELS[currentIdx + 1];
      setZoom(newZoom);
      applyZoom(newZoom);
    }
  };

  const zoomOut = () => {
    const currentIdx = ZOOM_LEVELS.indexOf(zoom);
    if (currentIdx > 0) {
      const newZoom = ZOOM_LEVELS[currentIdx - 1];
      setZoom(newZoom);
      applyZoom(newZoom);
    }
  };

  const resetZoom = () => {
    setZoom(100);
    applyZoom(100);
  };

  return (
    <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1" data-testid="zoom-control">
      <Button
        variant="ghost"
        size="icon"
        onClick={zoomOut}
        disabled={zoom <= 100}
        className="h-10 w-10"
        title="Reducir texto"
        data-testid="zoom-out-btn"
      >
        <ZoomOut className="h-5 w-5" />
      </Button>
      <Button
        variant="ghost"
        onClick={cycleZoom}
        className="h-10 px-3 font-bold text-base min-w-[60px]"
        title="Cambiar tamano de texto"
        data-testid="zoom-level-btn"
      >
        {zoom}%
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={zoomIn}
        disabled={zoom >= 150}
        className="h-10 w-10"
        title="Aumentar texto"
        data-testid="zoom-in-btn"
      >
        <ZoomIn className="h-5 w-5" />
      </Button>
      {zoom !== 100 && (
        <Button
          variant="ghost"
          size="icon"
          onClick={resetZoom}
          className="h-10 w-10"
          title="Restablecer"
          data-testid="zoom-reset-btn"
        >
          <RotateCcw className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default ZoomControl;
